import { ButtonProps } from 'components/library/Button';
import { positions, alignments } from 'components/library/Hero';

export const uniqueSlide = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    // Add video properties - using Cloudinary URLs
    videoDesktop: {
      playbackId: 'HMfn1TgirVAOwDN51CRI9xwb2v9ricFBIujMwq2pDl00',
      devPlaybackId: 'sk02sImOWMUxrYEB5euhNe02013jjLMlnUw1yu6wM3B2QY',
      alt: 'Hero background video',
    },
    videoMobile: {
      playbackId: 't4g1uPV9yE7EwLmQ6oqvDiiWlY2oqaGZgfVb7NmewPE',
      devPlaybackId: 'T01VMlb7Me5UZsEVwW01cHcb2gfR1xoXoHQeEGmT2Xn1M',
      alt: 'Hero background video',
    },
    title: 'The probiotic pioneering the future of gut health.',
    subhead:
      'DS-01® Daily Synbiotic is clinically proven to deliver relief from bloating, gas, and irregularity.*',
    alignment: 'left' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Is DS-01® Right for You?',
      url: '/is-ds01-right-for-you',
    },
  },
];

export const symptomResolutionSlide = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/library/hero/symptom_resolution_desktop.png',
      alt: 'DS-01 Daily Synbiotic welcome kit with jar and travel vial',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/library/hero/symptom_resolution_mobile.png',
      alt: 'DS-01 Daily Synbiotic welcome kit with jar and travel vial',
    },
    title: 'A healthy gut can<br />change your life.',
    subhead:
      'DS-01® is clinically proven to ease bloating, gas, and irregularity for everyday digestive comfort.',
    alignment: 'left' as alignments,
    position: 'center' as positions,
    hideFilter: true,
    desktopVerticalCenter: true,
    primaryButton: {
      label: 'Shop DS-01®',
      url: '/daily-synbiotic',
      color: 'snowwhite',
    } as ButtonProps,
    secondaryButton: {
      label: 'Take the Quiz',
      url: '/is-ds01-right-for-you',
      hideArrow: false,
    },
  },
];

export const ds01QuizHero = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1792431164/library/hero/ds01_d_2.png',
      alt: 'DS-01 Daily Synbiotic jar and capsules beside a glass of water',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1792431163/library/hero/ds01_m_2.png',
      alt: 'DS-01 Daily Synbiotic jar and capsules beside a glass of water',
    },
    title:
      'A life-changing<br />health routine, built<br />for your microbiome.',
    mobileTitle:
      'A life-changing health<br />routine, built for your<br />microbiome',
    titleMobileFontSize: '32px',
    subhead:
      'DS-01® delivers 24 clinically studied probiotic strains to support digestion, regularity, and whole-body health.',
    alignment: 'left' as alignments,
    position: 'midtop' as positions,
    mobilePosition: 'top' as positions,
    hideFilter: true,
    textColor: 'snowwhite' as const,
    desktopVerticalCenter: true,
    mobileImageFit: 'cover' as const,
    desktopImageFit: 'cover' as const,
    primaryButton: {
      label: 'Take the Quiz',
      url: '/is-ds01-right-for-you',
      color: 'snowwhite',
    } as ButtonProps,
    secondaryButton: {
      label: 'Shop Now',
      url: '/daily-synbiotic',
      hideArrow: false,
    },
  },
];

export const productCatalogSlide = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/library/hero/product_catalog_desktop.png',
      alt: 'Four jars of seed products',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/library/hero/product_catalog_mobile.png',
      alt: 'Four jars of seed products',
    },
    title: 'A life-changing health routine,<br />built for your microbiome.',
    mobileTitle:
      'A life-changing health routine, built for<br />your microbiome.',
    subhead:
      'Transform your gut health, energy, sleep, and nutrition with formulations designed for real results.',
    alignment: 'center' as alignments,
    mobileAlignment: 'left',
    position: 'top' as positions,
    titleVariant: 'catalog' as const,
    hideFilter: true,
    textColor: 'seedgreen',
    titleMobileFontSize: '32px',
    desktopMarginTop: '62px',
    primaryButton: {
      label: 'Shop Now',
      url: '/products',
      color: 'seedgreen',
    } as ButtonProps,
  },
];

export const npdSlide = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1757961084/library/hero/1F33D0BB-1F18-4F15-A509-6B4176C74039.png',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1757961084/library/hero/B683BB92-990D-49F8-87E5-C75B01AC37C0.png',
      alt: 'Default Hero image',
    },
    videoDesktop: {
      playbackId: 'OQT00yIcEsThXghvoJNw4xEcb59YtNufa2sbzDod2UfM',
      devPlaybackId: 'VXZaLYOrFa3RkMdDKD802cdt3Svzg00Nf6t3VuO2mfFa4',
      alt: 'Hero background video',
    },
    videoMobile: {
      playbackId: 'bog01892q2X3T1tNrTvN3B94MPbYS7KquR4KeizxU702A',
      devPlaybackId: 'bchIAv01zt40102LZCTNocDZTSPag00xD1bVv3NwR00R1lX4',
      alt: 'Hero background video',
    },
    title: 'Nutrition, energy, and sleep—advanced by microbiome science',
    subhead:
      "Seed's Co-Biotics nourish you and your microbiome to deliver targeted, daily benefits.",
    alignment: 'left' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Shop Now',
      url: '/products',
    },
  },
];

export const dmHeroSlide = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758834995/library/hero/211D8235-23AB-4048-BE58-A94CB81E28C0.png',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758834995/library/hero/6F2A5511-812B-44E0-9B18-5DC1FAD114B6.png',
      alt: 'Default Hero image',
    },
    videoDesktop: {
      playbackId: 'hWxdJlU2cGmmWGmD600YZmm7rQ1M4hf8p6pCMGoAXyQg',
      devPlaybackId: 'THQBKlEKeNrmDs6wyDIpRKJqV6MeaENSRqdqv02028z02A',
      alt: 'Hero background video',
    },
    videoMobile: {
      playbackId: 'o5W7B302Jd2q00mlzG01WTdIahLkDXGrba8o9pA5ornLko',
      devPlaybackId: 'LyJtBxnXr9018TwIlk4iEzTSvo02W87D02KVKpR87N01vy00',
      alt: 'Hero background video',
    },
    title: 'The multivitamin designed for <br /> you and your microbiome.',
    subhead:
      'DM-02® nourishes your body and beneficial gut bacteria to support key health functions.',
    alignment: 'left' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Is DM-02® right for you?',
      url: '/is-dm02-right-for-you',
    },
  },
];

export const bottomCentered = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'bottom' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const bottomLeft = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'left' as alignments,
    position: 'bottom' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const centered = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const centeredLeft = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'left' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const topCentered = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'top' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const topLeft = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'left' as alignments,
    position: 'top' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];

export const centeredSlides = [
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    pill: 'DS-01®',
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
  {
    backgroundDesktop: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887692/library/hero/hero-desktop.jpg',
      alt: 'Default Hero image',
    },
    backgroundMobile: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887663/library/hero/hero-mobile.jpg',
      alt: 'Default Hero image',
    },
    title: 'Heal Your Gut, Change Your Life.',
    subhead: 'Feel relief in just one week with DS-01®.',
    alignment: 'center' as alignments,
    position: 'center' as positions,
    primaryButton: {
      label: 'Learn More',
    },
    secondaryButton: {
      label: 'Shop Now',
    },
  },
];
